import React, { useEffect, useRef, useCallback } from 'react';
import ToyCard from '../blocks/ToyCard';
import '../styles/VerticalCatalog.css';
import CardsCard from '../blocks/CardsCard';
import PosterCard from '../blocks/PosterCard';
import { useLocation } from 'react-router-dom';
import AllCard from '../blocks/AllCard';

const VerticalCatalog = ({ products, loading, hasMore, onLoadMore, onCardClick }) => {
  const observerRef = useRef();
  const sentinelRef = useRef(null); // элемент-якорь в конце списка
  const location = useLocation();


  const handleObserver = useCallback((entries) => {
    const target = entries[0];
    if (target.isIntersecting && hasMore && !loading) {
      onLoadMore();
    }
  }, [hasMore, loading, onLoadMore]);

  useEffect(() => {
    if (loading) return;
    
    if (observerRef.current) observerRef.current.disconnect();
    
    observerRef.current = new IntersectionObserver(handleObserver, {
      root: null, // viewport
      rootMargin: '0px',
      threshold: 0.1
    });
    
    if (sentinelRef.current) {
      observerRef.current.observe(sentinelRef.current);
    }
    
    return () => observerRef.current?.disconnect();
  }, [handleObserver, loading]);

  return (
    <section className="verticalCatalog">
      <div className="catalogGrid">
        {products.map(product => (    
          location.pathname == '/archive' ?
          <AllCard key={product._id} product={product} onClick={() => onCardClick(product)}/> :
          product?.category == 'Doodle Toys' ? 
          <ToyCard key={product._id} product={product} onClick={() => onCardClick(product)} /> :
          product?.category == 'Открытки' ?
          <CardsCard key={product._id} product={product} onClick={() => onCardClick(product)} /> :
          <ToyCard key={product._id} product={product} onClick={() => onCardClick(product)} />
        ))}
      </div>
      
      {products?.length >= 4 && <div ref={sentinelRef} className="loadSentinel" />}
      
      {/* {loading && <div className="loadingIndicator">Загрузка...</div>} */}
    </section>
  );
};

export default VerticalCatalog;